function BookNow() {
    return (
        <>
            BOOK NOW
        </>
    )
}

export default BookNow